<!-- 首页-绑定微信-页面级 -->
<template>
  <div class='wechat'>
    <div class='content-wrap'>
      <div class='content'>
        <h3>绑定微信</h3>
        <p class='con-top'>随着再来人不断完善自身的服务，为了让您第一时间知道服务进度，我们在公众号上开发了新的功能，能让您在微信上收到最新的服务进度消息提醒。例如：当导师回传了您的项目文书，您将第一时间在微信公众号上收到消息提醒，助您更好的进行项目申请。</p>
        <div class='procedure'>
          <h4>具体步骤如下：</h4>
          <ul>
            <li>1.微信扫描二维码，关注“再来人 小V”公众号；</li>
            <li>2.点击“MSP平台”，输入用户名和密码，绑定微信；</li>
            <li>3.此后，您就可以第一时间收到服务平台上的消息；</li>
          </ul>
        </div>
        <div class='pic'>
          <img src=''
               class='qrcode'
               alt='扫一扫' />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.wechat {
  width: 1240px;
  padding: 20px;
  margin: 0 auto;
  .content-wrap {
    background: #fff;
    padding: 40px 180px;
    .content {
      font-size: 14px;
      color: #667483;
      letter-spacing: 0;
      line-height: 26px;
      h3 {
        font-size: 18px;
        color: #323c47;
        letter-spacing: 0;
        text-align: center;
        padding-bottom: 40px;
      }
      .procedure {
        h4 {
          font-size: 14px;
          color: #323c47;
          letter-spacing: 0;
          line-height: 26px;
        }
      }
      .pic {
        padding: 40px 0;
        img {
          width: 187px;
          height: 187px;
          display: block;
          border: none;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
